module.exports = __webpack_public_path__ + "img/ftx.2f3cd50e.svg";